import { Typography, Button, makeStyles, Box } from "@material-ui/core";
import ErrorIcon from "@material-ui/icons/Error";

const ERROR_TYPE_ERROR = 0;
const ERROR_TYPE_WARN = 1;
const ERROR_TYPE_WARN_WITH_MESSAGE = 2;
const ERROR_TYPE_WARN_YES_NO = 3;
const ERROR_TYPE_SIGNOUT = 4;
const ERROR_TYPE_SESSION_TIMEOUT = 5;

const useStyles = makeStyles((theme) => ({
  background: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: "#424242dd",
    width: "100%",
    height: "100vh",
    zIndex: 9990,
    display: "grid",
    placeItems: "center",
  },
  allContainer: {
    backgroundColor: theme.white,
    width: 345,
    height: 260,
    borderRadius: 12,
    position: "relative",
    display: "grid",
    gridTemplateRows: "110px auto 40px",
    justifyItems: "center",
  },
  title: {
    fontSize: 30,
    color: theme.orange,
    marginTop: 10,
  },
  errorTitle: {
    fontSize: 30,
    color: theme.red,
    marginTop: 10,
  },
  detail: {
    fontSize: 16,
    color: theme.black,
    marginTop: 15,
    alignSelf: "flex-start",
  },
  buttonContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
  },
  buttonContainertwoButtons: {
    display: "grid",
    gridTemplateColumns: "50% 50%",
    width: "100%",
  },
  button: {
    fontSize: 20,
    flex: 1,
    borderRadius: "0 0 12px 12px",
  },
  buttonLeftSide: {
    fontSize: 20,
    borderRadius: "0 0 0 12px",
  },
  buttonRightSide: { fontSize: 20, borderRadius: "0 0 12px 0" },
}));

const SFErrorDialog = ({ type, content, handleClose, onConfirm }) => {
  const classes = useStyles();
  return (
    <Box className={classes.background}>
      <Box className={classes.allContainer}>
        <ErrorHeader type={type} />
        <ErrorContent type={type} message={content} />
        {type === ERROR_TYPE_SIGNOUT ? (
          <Box className={classes.buttonContainertwoButtons}>
            <Button
              onClick={() => {
                handleClose();
              }}
              color="secondary"
              fullWidth
              variant="contained"
              className={[classes.button, classes.buttonLeftSide]}
            >
              Cancel
            </Button>

            <Button
              onClick={onConfirm}
              color="primary"
              fullWidth
              variant="contained"
              className={[classes.buttonRightSide]}
            >
              Log out
            </Button>
          </Box>
        ) : (
          <Box className={classes.buttonContainer}>
            <Button
              onClick={handleClose}
              color="primary"
              fullWidth
              variant="contained"
              className={[classes.button]}
            >
              OK
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );
};

const ErrorHeader = ({ type, title = "Error" }) => {
  const classes = useStyles();
  let error;
  if (type === ERROR_TYPE_ERROR || type === ERROR_TYPE_SIGNOUT) {
    error = (
      <>
        <ErrorIcon
          style={{
            color: "orange",
            width: 84,
            height: 84,
            alignSelf: "self-end",
            opacity: 0.5,
          }}
        />
      </>
    );
  } else
    error = (
      <Typography
        align="center"
        className={error ? classes.errorTitle : classes.title}
      >
        {title}
      </Typography>
    );

  return error;
};

const ErrorContent = ({ type, message = "Something went wrong" }) => {
  const classes = useStyles();
  if (message === "") message = "Error";
  if (type === ERROR_TYPE_SIGNOUT) message = "Do you want to log out and exit";
  return (
    <Box style={{ width: 345, overflow: "clip" }}>
      <Typography align="center" classes={{ root: classes.detail }}>
        {message}
      </Typography>
    </Box>
  );
};

export default SFErrorDialog;
export {
  ERROR_TYPE_ERROR,
  ERROR_TYPE_WARN,
  ERROR_TYPE_WARN_YES_NO,
  ERROR_TYPE_WARN_WITH_MESSAGE,
  ERROR_TYPE_SESSION_TIMEOUT,
  ERROR_TYPE_SIGNOUT,
};
